import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AppointmentsPageRoutingModule } from './appointments-routing.module';

import { AppointmentsPage } from './appointments.page';
import { IonicRatingModule } from 'ionic4-rating';
import { LaunchNavigator } from '@ionic-native/launch-navigator/ngx';
import { TrainerPageModule } from '../trainer/trainer.module';
import { DietmealPageModule } from '../dietmeal/dietmeal.module';
import { LabPageModule } from '../lab/lab.module';
import { NurseBookingPageModule } from '../nurse-booking/nurse-booking.module';
import { NewphysiotherapyPageModule } from '../newphysiotherapy/newphysiotherapy.module';
import { TrainingCenterPageModule } from '../training-center/training-center.module';
import { BookingRoomPageModule } from '../booking-room/booking-room.module';
import { PrescriptionPageModule } from '../prescription/prescription.module';
import { PhysioAppointmentPageModule } from '../physio-appointment/physio-appointment.module';
import { NursingPageModule } from '../nursing/nursing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AppointmentsPageRoutingModule,
    PhysioAppointmentPageModule,
    IonicRatingModule,
    TrainerPageModule,
    DietmealPageModule,
    LabPageModule,
    NurseBookingPageModule,
    NewphysiotherapyPageModule,
    TrainingCenterPageModule,
    BookingRoomPageModule,
    PrescriptionPageModule,
    NursingPageModule
  ],
  providers: [
    LaunchNavigator
  ],
  declarations: [AppointmentsPage]
})
export class AppointmentsPageModule { }
